import { gql } from '@apollo/client';
export const GET_LOGGED_IN_USER_QUERY = gql`
  fragment CommonUserFields on UsersPermissionsUser {
    id
    username
    email
    profilePicture {
      id
      url
      formats
    }
    phoneNr
    dashboardRole
  }

  fragment CommonHotelFieldMeQuery on Hotel {
    id
    name
    subdomain
    employees {
      ...CommonUserFields
    }
    owner {
      ...CommonUserFields
    }
    websiteUrl
  }

  query MeQuery {
    self {
      ...CommonUserFields
      receiveMarketingMessages
      ownerOf {
        ...CommonHotelFieldMeQuery
      }
      employeeOf {
        ...CommonHotelFieldMeQuery
      }
      provider
      roomNr
    }
  }
`;
